import { render, staticRenderFns } from "./uncollapsed_reviewer_list.vue?vue&type=template&id=323ab593"
import script from "./uncollapsed_reviewer_list.vue?vue&type=script&lang=js"
export * from "./uncollapsed_reviewer_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports